import { DocMagnifyingGlass } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconDocMagnifyingGlass12Line = createIcon(
  DocMagnifyingGlass,
  12,
  "Line"
);
export const IconDocMagnifyingGlass16Line = createIcon(
  DocMagnifyingGlass,
  16,
  "Line"
);
export const IconDocMagnifyingGlass20Line = createIcon(
  DocMagnifyingGlass,
  20,
  "Line"
);
export const IconDocMagnifyingGlass24Line = createIcon(
  DocMagnifyingGlass,
  24,
  "Line"
);
export const IconDocMagnifyingGlass32Line = createIcon(
  DocMagnifyingGlass,
  32,
  "Line"
);
export const IconDocMagnifyingGlass48Line = createIcon(
  DocMagnifyingGlass,
  48,
  "Line"
);
export const IconDocMagnifyingGlass64Line = createIcon(
  DocMagnifyingGlass,
  64,
  "Line"
);
